import axios from "axios";
import { handleRuntimeAccessError } from "./runtimeAccess";

const BACKEND = process.env.REACT_APP_BACKEND_URL || "";

// Student session is carried by the httpOnly `student_access_token` cookie — a distinct
// cookie name from staff/parent so all three sessions can coexist in one browser.
const sapi = axios.create({ baseURL: `${BACKEND}/api`, withCredentials: true });

// MOB-SESSION web parity: the student realm now has POST /student/auth/refresh (cookie-carried) —
// same single-flight 401→refresh→retry as the parent transport; auth endpoints excluded (no loops).
let refreshInFlight = null;
const AUTH_ENDPOINTS = /\/student\/auth\/(login|claim|refresh|logout|reset)/;

sapi.interceptors.response.use(
  (response) => response,
  async (error) => {
    handleRuntimeAccessError(error);
    const cfg = error?.config;
    if (error?.response?.status === 401 && cfg && !cfg._sessionRetried
        && !AUTH_ENDPOINTS.test(cfg.url || "")) {
      cfg._sessionRetried = true;
      try {
        if (!refreshInFlight) {
          refreshInFlight = sapi.post("/student/auth/refresh")
            .finally(() => { refreshInFlight = null; });
        }
        await refreshInFlight;
        return await sapi.request(cfg);
      } catch (e) { /* refresh failed — the original 401 stays authoritative */ }
    }
    return Promise.reject(error);
  }
);

export default sapi;
